export default __webpack_public_path__ + "static/media/close-black.eb9725c9.svg";